import $ from 'jquery';
import modaal from 'modaal';
import 'modaal/dist/css/modaal.min.css';
import '../../css/Assets/modaal.custom.css'

$(() => {
    const padding = 100;
    $('.js_modalIFrame').modaal({
        type: 'iframe',
        width: $(window).width(),
        height: $(window).height() - padding,
        overlay_close: false,
        source: function(element, src) {
            return element.eq(0).attr('href') || element.attr('href') || src;
        }
    });

    $('.js_mailModalSubmit').on('click', e => {
        e.preventDefault();
        if (formValidator()) {
            $('.js_mail').submit();
        }
    });

    /**
     *
     * @returns {boolean}
     */
    function formValidator() {
        const $js_mail = $('.js_mail');
        let validate = {
            required: {
                subject: {
                    check: true,
                    messages: []
                },
                content: {
                    check: true,
                    messages: []
                },
                email_from_address: {
                    check: true,
                    messages: []
                }
            },
            nullable: {
                email_from_name: {
                    check: true,
                    messages: []
                }
            }
        };
        let subject = $js_mail.find('[name=subject]').val();
        let content = $js_mail.find('[name=content]').val();
        let email_from_name = $js_mail.find('[name=email_from_name]').val();
        let email_from_address = $js_mail.find('[name=email_from_address]').val();

        if (subject === '') {
            validate.required.subject.check = false;
            validate.required.subject.messages.push("件名を入力してください\n");
        }
        if (content === '') {
            validate.required.content.check = false;
            validate.required.content.messages.push("本文を入力してください\n");
        }
        if (email_from_name === '') {
            validate.nullable.email_from_name.check = false;
            validate.nullable.email_from_name.messages.push("差出人名が入力されていません\n");
        }
        if (email_from_address === 'no_set') {
            validate.required.email_from_address.check = false;
            validate.required.email_from_address.messages.push("差出人アドレスが入力されていません\n");
        }

        // 必須項目チェック&アラート
        let require_message = '';
        for (let item in validate.required) {
            if(!validate.required[item].check){
                require_message += validate.required[item].messages.join('');
            }
        }
        if(require_message !== '') {
            alert(require_message);
            return false;
        }

        // 項目チェック&アラート
        let nullable_message = '';
        for (let item in validate.nullable) {
            if(!validate.nullable[item].check){
                nullable_message += validate.nullable[item].messages.join('');
            }
        }
        if(nullable_message !== '') {
            nullable_message += "\n";
            nullable_message += 'メールを送信しますか？';
            return confirm(nullable_message);
        } else {
            return confirm('メールを送信しますか？');
        }

        return true;
    }

    const $autoModalClose = $('.js_autoModalClose');
    if($autoModalClose.length > 0){
        const $modalIFrame = $('.js_modalIFrame', parent.document);
        if ($modalIFrame.length > 0) {
            let closeSeconds = 10;

            let $seconds = $autoModalClose.find('.seconds');
            if($autoModalClose.attr('data-seconds')){
                closeSeconds = parseInt($autoModalClose.attr('data-seconds'), 10);
            }

            $seconds.text(closeSeconds);
            $autoModalClose.show();

            let timer = setInterval(() => {
                if(closeSeconds > 0) {
                    $seconds.text(closeSeconds--);
                }else {
                    clearInterval(timer);
                    $modalIFrame.each((i, el) => {
                        // $(el).modaal('close')
                        $('.modaal-close', parent.document).trigger('click');
                    });
                }
            }, 1000);
        }
    }

});
